export interface GalleryImage {
  id: string;
  src: string;
  alt: string;
  category: string;
  title: string;
}

export const GALLERY_CATEGORIES = [
  "All",
  "Storage Tanks",
  "Pipes & Fittings",
  "Ductings",
  "Scrubbers",
  "Vessels",
  "Factory",
];

export const GALLERY_IMAGES: GalleryImage[] = [
  {
    id: "g1",
    src: "/STORAGE1.webp",
    alt: "FRP Storage Tank",
    category: "Storage Tanks",
    title: "Chemical Storage Tank – 50,000L",
  },
  {
    id: "g2",
    src: "/PIPE1.webp",
    alt: "FRP Pipes",
    category: "Pipes & Fittings",
    title: "FRP Piping System – DN 500",
  },
  {
    id: "g3",
    src: "/duct.webp",
    alt: "FRP Ducting",
    category: "Ductings",
    title: "PP FRP Ducting – Chemical Plant",
  },
  {
    id: "g4",
    src: "/scrubber.webp",
    alt: "FRP Scrubber",
    category: "Scrubbers",
    title: "Packed Bed Scrubber – 25,000 CMH",
  },
  {
    id: "g5",
    src: "/vessel.webp",
    alt: "Industrial Vessel",
    category: "Vessels",
    title: "Reaction Vessel – 10,000L",
  },
  {
    id: "g6",
    src: "/PIC1.webp",
    alt: "Factory View",
    category: "Factory",
    title: "SS Plastic Manufacturing Unit – Vapi",
  },
  {
    id: "g7",
    src: "/STORAGE2.webp",
    alt: "Horizontal Tank",
    category: "Storage Tanks",
    title: "Horizontal FRP Tank – Acid Storage",
  },
  {
    id: "g8",
    src: "/gutter.webp",
    alt: "Chimney Stack",
    category: "Scrubbers",
    title: "FRP Chimney Stack – 30m Height",
  },
//   {
//     id: "g9",
//     src: "/pipe.webp",
//     alt: "FRP Fittings",
//     category: "Pipes & Fittings",
//     title: "FRP Flanges & Fittings Assembly",
//   },
  {
    id: "g10",
    src: "/STORAGE3.webp",
    alt: "FRP Storage Tank Installation",
    category: "Storage Tanks",
    title: "FRP Tank Installation Site",
  },
//   {
//     id: "g11",
//     src: "/PIC1 (1).webp",
//     alt: "Factory Inside",
//     category: "Factory",
//     title: "Fabrication Workshop – Vapi Unit",
//   },
];